import { NSButton } from 'bricks';
import NSModal from 'bricks/NSModal/NSModal';
import RenderIf from 'components/RenderIf/RenderIf';
import { getOverwriteBudgetDatesModalText } from 'views/ProFormaTable/helpers';

export interface IOverwriteBudgetDatesModalProps {
    isOpen: boolean;
    toggle: () => void;
    handleCancel: () => void;
    handleConfirm: (shouldOverwriteBudgetLineDates: boolean) => void;
    areBudgetLineDatesOutOfBounds: boolean;
}

export const OverwriteBudgetDatesModal = ({
    isOpen,
    toggle,
    handleCancel,
    handleConfirm,
    areBudgetLineDatesOutOfBounds,
}: IOverwriteBudgetDatesModalProps) => {
    const { header, title, subtitle } = getOverwriteBudgetDatesModalText(areBudgetLineDatesOutOfBounds);

    const keepExistingDate = () => {
        handleCancel();
        toggle();
    };

    const updateNewDate = (overwriteBudgetLineDates: boolean) => {
        handleConfirm(overwriteBudgetLineDates);
        toggle();
    };

    return (
        <NSModal
            isOpen={isOpen}
            toggle={keepExistingDate}
            modalHeaderText={header}
            modalHeaderClassName="bg-primary text-dark"
            customFooter={(
                <div>
                    <NSButton
                        text="Cancel"
                        outline={false}
                        callback={keepExistingDate}
                    />
                    <RenderIf isTrue={!areBudgetLineDatesOutOfBounds}>
                        <NSButton
                            text="Keep previous dates"
                            color="secondary"
                            outline={false}
                            callback={() => updateNewDate(false)}
                        />
                    </RenderIf>
                    <NSButton
                        className="ml-2"
                        text={areBudgetLineDatesOutOfBounds ? 'Confirm' : 'Overwrite'}
                        color="primary"
                        outline={false}
                        callback={() => updateNewDate(true)}
                    />
                </div>
            )}
        >
            <div className="text-dark">{title}</div>
            <div>{subtitle}</div>
        </NSModal>
    );
};

export default OverwriteBudgetDatesModal;
